// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Montserrat:100,100i,200,200i,300,300i,400,400i,500,500i,600,600i,700,700i,800,800i,900,900i&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes NavfadeIn 
{
    0% { opacity: 0; }
    100% { opacity: 1; }
}

.navigation-bar
{
    position: fixed;
    z-index: 99;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    width: 100vw;
    transition: background-color .5s ease;
}

.navigation-menu
{
    font-family: 'Montserrat', sans-serif;
    font-weight: 500;
    font-size: 17px;
    justify-content: space-evenly;
    align-items: center;
    display: flex;
    padding: 15px 25px 15px 25px;
    gap: 16px;
    transition: background-color .5s ease;
    max-width: 1600px;
    width: 100vw;
    animation: NavfadeIn 1s;
}

.navigation-text
{
    color : white;
    line-height: 10px;
    margin: 5px 15px 5px 15px;
    transition : all 0.2s linear; 
    cursor: pointer;
}

.navigation-text:hover
{
    color : var(--accent-color);
}

#navigation-login
{
    color : white;
    position: relative;
    background-color: transparent;
    border-color: white;
    border-width: 1px;
    border-radius : 10px;
    padding : 12px 15px;
    margin-right : 20px;
    margin-left : 15px;
    font-size: 15px;
    font-weight: 600;
    overflow: hidden;
    z-index: 999;
}

#navigation-login:hover
{
    color : var(--dark-secondary-color);
    border-color: var(--accent-color);
    z-index: 999;
}

#navigation-login::after
{
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    border-radius : 9px;
    background-color: var(--accent-color);
    z-index: -1;
    transform-origin: top right;
    transform: scaleX(0);
    transition: transform 0.5s cubic-bezier(0.86, 0, 0.07, 1);
    transition-timing-function: cubic-bezier(0.86, 0, 0.07, 1);
}

  #navigation-login:hover::after
{
    transform: scaleX(1);
    transform-origin: top left;
}

#navigation-search-bar-input
{
    width: 100%;
    background-color: transparent;
    color: white;
    padding-right: 40px;
}


#navigation-search-bar-icon
{
    position: absolute;
    height: 22px;
    right : 18px;
    top: 7px;
}

.navbar-logo 
{
    max-height: 55px;
    margin-right : 20px;
}

.navigation-hamburger
{
    display : none;
    cursor : pointer;
    justify-content: space-evenly;
    align-items: center;
    padding: 18px 25px 18px 25px;
    gap: 0px;
    max-width: 1600px;
    width: 100vw;
}

.navigation-line
{
    display : block;
    width : 25px;
    height : 3px;
    margin : 5px auto;
    transition : all 0.3s ease-in-out;
    background-color : white;
}

.navigation-bar-not-fixed 
{
    position: relative;
    opacity: 100%;
}

.navigation-bar-scrolled 
{
    background-color: var(--dark-secondary-color);
    transition: background-color 1s ease;
}

#navigation-logo-container
{
    display: flex;
    justify-content: center;
    position: absolute;
    left: 0px;
    width: 100%;
}

.user-profile-image
{
    width : 52px;
    border-radius: 50%;
    margin: 0px 15px 0px 10px;
}
 
@media all and (max-width : 1200px)
{
    .navigation-menu
    {
        gap: 0px;
        font-size: 15px;
    }

    #navigation-login
    {
        margin-right : 0px;
        padding: 10px 10px;
    }
}

@media all and (max-width : 850px)
{
    .navigation-menu 
    {
        flex-direction: column;
        padding-top: 50px;
        font-size: 18px;
        width: 50vw
    }

    .navigation-hamburger
    {
        z-index : 9999;
        position: fixed;
        display: flex;
        justify-content: space-between;
        align-items: center;
        width : 100vw;
        top: 0px;
        background-color: var(--dark-secondary-color);
        padding: 12px 25px 12px 25px;
    }

    .navbar-logo
    {
        display: none;
        margin-right : 0px;
    }

    .navbar-logo.mobileLogo
    {
        margin-right : 0px;
        max-height: 42px;
        display: block;
        animation: NavfadeIn 1s;
    }

    .navigation-hamburger.active .navigation-line:nth-child(2)
    {
        opacity : 0;
    }

    .navigation-hamburger.active .navigation-line:nth-child(1)
    {
        transform : translateY(8px) rotate(45deg);
    }

    .navigation-hamburger.active .navigation-line:nth-child(3)
    {
        transform : translateY(-8px) rotate(-45deg);
    }
    
    .navigation-bar
    {
        background-color: var(--dark-secondary-color);
        left : -100%;
        width: 300px;
        height: 100vh;
        transition : 0.5s ease-in-out;
        padding-top: 50px;
        align-items: center;
    }

    .navigation-bar.active 
    {
        left : 0vw;
    }

    .navigation-text
    {
        margin: 15px 0px;
        margin-bottom: 50px;
    }

    #navigation-login 
    {
        margin-right: 0px;
        margin-left: 0px; 
        padding : 15px 15px;
        margin: 15px 0px;
    }

    #navbar-login
    {
        margin: 15px 0px;
    }

    .navigation-bar-not-fixed
    {
        position: fixed;
        opacity: 100%;
    }

    /* .navigation-bar-scrolled
    {
        background-color: transparent;
    } */

    #navigation-search-bar 
    {
        height: 40px;
        z-index: 1;
        background-color: transparent;
        width: 90%;
        top: 80px;
        left: 5%;
        transition: background-color 1s ease;
        margin-right: 0px;
    }

    .user-profile-image
    {
        width : 42px;
        margin: 0px;
        border-color: white;
        border-width: 1.5px;
    }
}

@media all and (max-width : 480px)
{
    .navigation-bar
    {
        width: 250px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/navbar.css"],"names":[],"mappings":"AAEA;;IAEI,KAAK,UAAU,EAAE;IACjB,OAAO,UAAU,EAAE;AACvB;;AAEA;;IAEI,eAAe;IACf,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,qCAAqC;AACzC;;AAEA;;IAEI,qCAAqC;IACrC,gBAAgB;IAChB,eAAe;IACf,6BAA6B;IAC7B,mBAAmB;IACnB,aAAa;IACb,4BAA4B;IAC5B,SAAS;IACT,qCAAqC;IACrC,iBAAiB;IACjB,YAAY;IACZ,uBAAuB;AAC3B;;AAEA;;IAEI,aAAa;IACb,iBAAiB;IACjB,yBAAyB;IACzB,4BAA4B;IAC5B,eAAe;AACnB;;AAEA;;IAEI,2BAA2B;AAC/B;;AAEA;;IAEI,aAAa;IACb,kBAAkB;IAClB,6BAA6B;IAC7B,mBAAmB;IACnB,iBAAiB;IACjB,oBAAoB;IACpB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;AAChB;;AAEA;;IAEI,mCAAmC;IACnC,iCAAiC;IACjC,YAAY;AAChB;;AAEA;;IAEI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,qCAAqC;IACrC,WAAW;IACX,2BAA2B;IAC3B,oBAAoB;IACpB,yDAAyD;IACzD,0DAA0D;AAC9D;;EAEE;;IAEE,oBAAoB;IACpB,0BAA0B;AAC9B;;AAEA;;IAEI,WAAW;IACX,6BAA6B;IAC7B,YAAY;IACZ,mBAAmB;AACvB;;;AAGA;;IAEI,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,QAAQ;AACZ;;AAEA;;IAEI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;;IAEI,cAAc;IACd,gBAAgB;IAChB,6BAA6B;IAC7B,mBAAmB;IACnB,4BAA4B;IAC5B,QAAQ;IACR,iBAAiB;IACjB,YAAY;AAChB;;AAEA;;IAEI,eAAe;IACf,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,iCAAiC;IACjC,wBAAwB;AAC5B;;AAEA;;IAEI,kBAAkB;IAClB,aAAa;AACjB;;AAEA;;IAEI,6CAA6C;IAC7C,oCAAoC;AACxC;;AAEA;;IAEI,aAAa;IACb,uBAAuB;IACvB,kBAAkB;IAClB,SAAS;IACT,WAAW;AACf;;AAEA;;IAEI,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;;IAEI;;QAEI,QAAQ;QACR,eAAe;IACnB;;IAEA;;QAEI,kBAAkB;QAClB,kBAAkB;IACtB;AACJ;;AAEA;;IAEI;;QAEI,sBAAsB;QACtB,iBAAiB;QACjB,eAAe;QACf;IACJ;;IAEA;;QAEI,cAAc;QACd,eAAe;QACf,aAAa;QACb,8BAA8B;QAC9B,mBAAmB;QACnB,aAAa;QACb,QAAQ;QACR,6CAA6C;QAC7C,4BAA4B;IAChC;;IAEA;;QAEI,aAAa;QACb,kBAAkB;IACtB;;IAEA;;QAEI,kBAAkB;QAClB,gBAAgB;QAChB,cAAc;QACd,uBAAuB;IAC3B;;IAEA;;QAEI,WAAW;IACf;;IAEA;;QAEI,yCAAyC;IAC7C;;IAEA;;QAEI,2CAA2C;IAC/C;;IAEA;;QAEI,6CAA6C;QAC7C,YAAY;QACZ,YAAY;QACZ,aAAa;QACb,6BAA6B;QAC7B,iBAAiB;QACjB,mBAAmB;IACvB;;IAEA;;QAEI,UAAU;IACd;;IAEA;;QAEI,gBAAgB;QAChB,mBAAmB;IACvB;;IAEA;;QAEI,iBAAiB;QACjB,gBAAgB;QAChB,mBAAmB;QACnB,gBAAgB;IACpB;;IAEA;;QAEI,gBAAgB;IACpB;;IAEA;;QAEI,eAAe;QACf,aAAa;IACjB;;IAEA;;;OAGG;;IAEH;;QAEI,YAAY;QACZ,UAAU;QACV,6BAA6B;QAC7B,UAAU;QACV,SAAS;QACT,QAAQ;QACR,oCAAoC;QACpC,iBAAiB;IACrB;;IAEA;;QAEI,YAAY;QACZ,WAAW;QACX,mBAAmB;QACnB,mBAAmB;IACvB;AACJ;;AAEA;;IAEI;;QAEI,YAAY;IAChB;AACJ","sourcesContent":["@import url(\"https://fonts.googleapis.com/css?family=Montserrat:100,100i,200,200i,300,300i,400,400i,500,500i,600,600i,700,700i,800,800i,900,900i&display=swap\");\n\n@keyframes NavfadeIn \n{\n    0% { opacity: 0; }\n    100% { opacity: 1; }\n}\n\n.navigation-bar\n{\n    position: fixed;\n    z-index: 99;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n    width: 100vw;\n    transition: background-color .5s ease;\n}\n\n.navigation-menu\n{\n    font-family: 'Montserrat', sans-serif;\n    font-weight: 500;\n    font-size: 17px;\n    justify-content: space-evenly;\n    align-items: center;\n    display: flex;\n    padding: 15px 25px 15px 25px;\n    gap: 16px;\n    transition: background-color .5s ease;\n    max-width: 1600px;\n    width: 100vw;\n    animation: NavfadeIn 1s;\n}\n\n.navigation-text\n{\n    color : white;\n    line-height: 10px;\n    margin: 5px 15px 5px 15px;\n    transition : all 0.2s linear; \n    cursor: pointer;\n}\n\n.navigation-text:hover\n{\n    color : var(--accent-color);\n}\n\n#navigation-login\n{\n    color : white;\n    position: relative;\n    background-color: transparent;\n    border-color: white;\n    border-width: 1px;\n    border-radius : 10px;\n    padding : 12px 15px;\n    margin-right : 20px;\n    margin-left : 15px;\n    font-size: 15px;\n    font-weight: 600;\n    overflow: hidden;\n    z-index: 999;\n}\n\n#navigation-login:hover\n{\n    color : var(--dark-secondary-color);\n    border-color: var(--accent-color);\n    z-index: 999;\n}\n\n#navigation-login::after\n{\n    content: \"\";\n    position: absolute;\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    border-radius : 9px;\n    background-color: var(--accent-color);\n    z-index: -1;\n    transform-origin: top right;\n    transform: scaleX(0);\n    transition: transform 0.5s cubic-bezier(0.86, 0, 0.07, 1);\n    transition-timing-function: cubic-bezier(0.86, 0, 0.07, 1);\n}\n\n  #navigation-login:hover::after\n{\n    transform: scaleX(1);\n    transform-origin: top left;\n}\n\n#navigation-search-bar-input\n{\n    width: 100%;\n    background-color: transparent;\n    color: white;\n    padding-right: 40px;\n}\n\n\n#navigation-search-bar-icon\n{\n    position: absolute;\n    height: 22px;\n    right : 18px;\n    top: 7px;\n}\n\n.navbar-logo \n{\n    max-height: 55px;\n    margin-right : 20px;\n}\n\n.navigation-hamburger\n{\n    display : none;\n    cursor : pointer;\n    justify-content: space-evenly;\n    align-items: center;\n    padding: 18px 25px 18px 25px;\n    gap: 0px;\n    max-width: 1600px;\n    width: 100vw;\n}\n\n.navigation-line\n{\n    display : block;\n    width : 25px;\n    height : 3px;\n    margin : 5px auto;\n    transition : all 0.3s ease-in-out;\n    background-color : white;\n}\n\n.navigation-bar-not-fixed \n{\n    position: relative;\n    opacity: 100%;\n}\n\n.navigation-bar-scrolled \n{\n    background-color: var(--dark-secondary-color);\n    transition: background-color 1s ease;\n}\n\n#navigation-logo-container\n{\n    display: flex;\n    justify-content: center;\n    position: absolute;\n    left: 0px;\n    width: 100%;\n}\n\n.user-profile-image\n{\n    width : 52px;\n    border-radius: 50%;\n    margin: 0px 15px 0px 10px;\n}\n \n@media all and (max-width : 1200px)\n{\n    .navigation-menu\n    {\n        gap: 0px;\n        font-size: 15px;\n    }\n\n    #navigation-login\n    {\n        margin-right : 0px;\n        padding: 10px 10px;\n    }\n}\n\n@media all and (max-width : 850px)\n{\n    .navigation-menu \n    {\n        flex-direction: column;\n        padding-top: 50px;\n        font-size: 18px;\n        width: 50vw\n    }\n\n    .navigation-hamburger\n    {\n        z-index : 9999;\n        position: fixed;\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        width : 100vw;\n        top: 0px;\n        background-color: var(--dark-secondary-color);\n        padding: 12px 25px 12px 25px;\n    }\n\n    .navbar-logo\n    {\n        display: none;\n        margin-right : 0px;\n    }\n\n    .navbar-logo.mobileLogo\n    {\n        margin-right : 0px;\n        max-height: 42px;\n        display: block;\n        animation: NavfadeIn 1s;\n    }\n\n    .navigation-hamburger.active .navigation-line:nth-child(2)\n    {\n        opacity : 0;\n    }\n\n    .navigation-hamburger.active .navigation-line:nth-child(1)\n    {\n        transform : translateY(8px) rotate(45deg);\n    }\n\n    .navigation-hamburger.active .navigation-line:nth-child(3)\n    {\n        transform : translateY(-8px) rotate(-45deg);\n    }\n    \n    .navigation-bar\n    {\n        background-color: var(--dark-secondary-color);\n        left : -100%;\n        width: 300px;\n        height: 100vh;\n        transition : 0.5s ease-in-out;\n        padding-top: 50px;\n        align-items: center;\n    }\n\n    .navigation-bar.active \n    {\n        left : 0vw;\n    }\n\n    .navigation-text\n    {\n        margin: 15px 0px;\n        margin-bottom: 50px;\n    }\n\n    #navigation-login \n    {\n        margin-right: 0px;\n        margin-left: 0px; \n        padding : 15px 15px;\n        margin: 15px 0px;\n    }\n\n    #navbar-login\n    {\n        margin: 15px 0px;\n    }\n\n    .navigation-bar-not-fixed\n    {\n        position: fixed;\n        opacity: 100%;\n    }\n\n    /* .navigation-bar-scrolled\n    {\n        background-color: transparent;\n    } */\n\n    #navigation-search-bar \n    {\n        height: 40px;\n        z-index: 1;\n        background-color: transparent;\n        width: 90%;\n        top: 80px;\n        left: 5%;\n        transition: background-color 1s ease;\n        margin-right: 0px;\n    }\n\n    .user-profile-image\n    {\n        width : 42px;\n        margin: 0px;\n        border-color: white;\n        border-width: 1.5px;\n    }\n}\n\n@media all and (max-width : 480px)\n{\n    .navigation-bar\n    {\n        width: 250px;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
